export const CouponStatus = {
  isNewlyRegisteredUser: false, 	// 默认不是新用户
  isCouponMaskCanceld: false, 	// 是否取消了优惠券的显示
  isNewUserCouponClaimed: false 	// 新用户注册优惠券是否已经领取
};
